"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildLoginUrl = void 0;
const constants_1 = require("./constants");
const interface_1 = require("./interface");
const utils_1 = require("./utils");
const buildLoginUrl = ({ loginUrl, screen, phoneNumber, clientId, customEdit, }) => {
    const url = new URL(loginUrl);
    const params = {
        [constants_1.URL_QUERY_PARAMS.SCREEN]: screen === interface_1.ScreenType.OTP_INPUT_SCREEN
            ? constants_1.DEFAULT_QUERY_PARAMS[constants_1.URL_QUERY_PARAMS.SCREEN]
            : undefined,
        [constants_1.URL_QUERY_PARAMS.IFRAME]: constants_1.DEFAULT_QUERY_PARAMS[constants_1.URL_QUERY_PARAMS.IFRAME],
        [constants_1.URL_QUERY_PARAMS.STATE]: (0, utils_1.getAbsoluteLoginUrl)(constants_1.DEFAULT_QUERY_PARAMS[constants_1.URL_QUERY_PARAMS.STATE]),
        [constants_1.URL_QUERY_PARAMS.MOBILE]: phoneNumber,
        [constants_1.URL_QUERY_PARAMS.CUSTOM_EDIT]: customEdit
            ? constants_1.DEFAULT_QUERY_PARAMS[constants_1.URL_QUERY_PARAMS.CUSTOM_EDIT]
            : undefined,
        [constants_1.URL_QUERY_PARAMS.CLIENT_ID]: clientId,
        [constants_1.URL_QUERY_PARAMS.DEVICE_TYPE]: (0, utils_1.getDeviceType)(),
    };
    Object.entries(params).forEach(([key, value]) => {
        value ? url.searchParams.set(key, value) : url.searchParams.delete(key);
    });
    return url.toString();
};
exports.buildLoginUrl = buildLoginUrl;
//# sourceMappingURL=builder.js.map